export const NoPetsIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke="black" strokeWidth="0.7" />
        <path
          d="M8.27004 15.2642C9.60536 12.5457 10.273 11.1864 11.2341 10.8626C11.7314 10.6949 12.2686 10.6949 12.766 10.8626C13.727 11.1864 14.3947 12.5457 15.73 15.2642L16.47 16.7708C16.8149 17.473 16.9874 17.8242 17.0283 18.0634C17.1977 19.056 16.4633 19.9709 15.4741 19.9997C15.2356 20.0066 14.8632 19.9046 14.1184 19.7004C13.6928 19.5838 13.48 19.5255 13.2671 19.4824C12.4306 19.3131 11.5695 19.3131 10.7329 19.4824C10.5201 19.5255 10.3073 19.5838 9.88166 19.7004C9.13686 19.9046 8.76446 20.0066 8.52598 19.9997C7.53669 19.9709 6.80234 19.056 6.97177 18.0634C7.01262 17.8242 7.18509 17.473 7.53003 16.7708L8.27004 15.2642Z"
          stroke={fill}
          strokeWidth="0.7"
        />
        <path
          d="M7.0693 6.97049C7.41609 8.34376 8.39669 9.25815 9.25952 9.01284C10.1224 8.76753 10.5407 7.45541 10.1939 6.08214C9.8471 4.70887 8.86651 3.79448 8.00367 4.03979C7.14084 4.2851 6.72251 5.59722 7.0693 6.97049Z"
          stroke={fill}
          strokeWidth="0.7"
        />
        <path
          d="M16.9308 6.97049C16.584 8.34376 15.6034 9.25815 14.7405 9.01284C13.8777 8.76753 13.4594 7.45541 13.8062 6.08214C14.153 4.70887 15.1336 3.79448 15.9964 4.03979C16.8592 4.2851 17.2776 5.59722 16.9308 6.97049Z"
          stroke={fill}
          strokeWidth="0.7"
        />
        <path
          d="M3.74882 12.6713C4.12777 13.686 5.01873 14.3024 5.73883 14.0479C6.45894 13.7935 6.7355 12.7646 6.35655 11.7498C5.9776 10.735 5.08664 10.1187 4.36653 10.3731C3.64643 10.6276 3.36987 11.6565 3.74882 12.6713Z"
          stroke={fill}
          strokeWidth="0.7"
        />
        <path
          d="M20.2512 12.6713C19.8723 13.686 18.9813 14.3024 18.2612 14.0479C17.5411 13.7935 17.2646 12.7646 17.6435 11.7498C18.0225 10.735 18.9134 10.1187 19.6335 10.3731C20.3536 10.6276 20.6302 11.6565 20.2512 12.6713Z"
          stroke={fill}
          strokeWidth="0.7"
        />
        <path
          d="M18.5 5.5L5.50002 18.4998"
          stroke="black"
          strokeWidth="0.7"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
